import React, { useState, useEffect, useRef } from 'react'
import {
  Wrapper,
  ContentWrapper,
  RewardWrapper,
  InviteWrapper,
  CopyButton,
} from './earnStyle'
import { EarnBtn } from 'src/components/Global/Button/Button'
import { referral } from 'src/assets'
import { CopyInput } from 'src/components/Global/Input/Input'
import { CopyBtn } from 'src/components/Global/Button/Button'
import { addNairaSign } from 'src/utils/addNairaSign'
import { RootState } from 'src/redux/root-reducer'
import { connect, useDispatch } from 'react-redux'
import { getMyRefDetailsAction } from 'src/redux/actions/referralAction'

const Earn = ({ refData }: any) => {
  const [toggleState, setToggleState] = useState(1)
  const { claimedBonus, pendingBonus, referralCode } = refData?.referralCode
  const [copied, setCopied] = useState('')
  const [showAlert, setShowAlert] = useState(false)
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(getMyRefDetailsAction())
  }, [])
  const toggleTab = (index: any) => {
    setToggleState(index)
  }
  const linkRef: any = useRef(null)
  const copyCodeToClipBoard = (code: string) => {
    if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code)
      setShowAlert(true)
    }
  }

  const copyToClipBoard = (ref: any) => {
    ref.current.select()
    document.execCommand('copy')
    setShowAlert(true)
  }
  const DATA = `https://app.fandksavings.com/account/register?ref=${referralCode}`
  return (
    <Wrapper>
      <div className="header-welcome">
        <h2 className="title">Referrals</h2>
        <p className="earn_text">Earn money by inviting friends</p>
      </div>
      <ContentWrapper>
        <div>
          <EarnBtn
            className={toggleState === 1 ? 'active' : ''}
            onClick={() => toggleTab(1)}
          >
            Invite Friend
          </EarnBtn>
        </div>
        <div>
          <EarnBtn
            className={toggleState === 2 ? 'active' : ''}
            onClick={() => toggleTab(2)}
          >
            Claim Reward
          </EarnBtn>
        </div>
      </ContentWrapper>

      <InviteWrapper>
        <div
          className={
            toggleState === 1 ? 'container active-container' : 'container'
          }
        >
          <div className="first">
            <div className="image-first">
              <img src={referral} alt="" className="image" />
            </div>
            <div className="content">
              <h2>Invite & Earn ₦250</h2>
              <p>
                Invite your friends to join and get the reward as soon as they
                start using F&K Savings
              </p>
              <CopyInput type="text" ref={linkRef} value={DATA} readOnly />
              <div className="content-copy">
                <CopyButton
                  onClick={() => {
                    setCopied(DATA)

                    copyCodeToClipBoard(DATA)
                  }}
                >
                  {copied ? 'Copied' : 'Copy'}
                </CopyButton>
              </div>
            </div>
          </div>
        </div>
      </InviteWrapper>
      <RewardWrapper>
        <div
          className={
            toggleState === 2 ? 'container active-container' : 'container'
          }
        >
          <div className="second">
            <div className="this-div">
              <h2>{addNairaSign(claimedBonus)}</h2>
              <p>Claimed</p>
            </div>
            <span></span>
            <div>
              <h2>{addNairaSign(pendingBonus)}</h2>
              <p>Pending</p>
            </div>
          </div>
          <p className="withdraw">
            You cannot withdraw till your money gets up to {addNairaSign(5000)}
          </p>
        </div>
      </RewardWrapper>
    </Wrapper>
  )
}

const mapStateToProps = (state: RootState) => {
  return {
    refData: state.referrals.myRefDetails,
  }
}

export default connect(mapStateToProps)(Earn)
